<template>
  <div>
    <PageTitle
      title="waiter View"
      :backBtn="true"
      :editRoute="'/waiter/edit/' + this.$route.params.id"
      :permission="'waiter Edit'"
      :resetPasswordPermission="'waiter Reset Password'"
      :resetpass="true"
   
    />
  
    <v-container fluid>
      <!-- Page Title -->

      <v-row>
        <v-col cols="12" sm="12" md="4" lg="4">
          <v-card>
          
            <v-list two-line class="pl-10 pr-10">
              <v-list-item href="#">
                <v-list-item-action>
                  <v-icon color="indigo">mdi-id-card</v-icon>
                </v-list-item-action>
             <v-row>
                <v-list-item-content>
                  <v-col>
                  <v-list-item-title
                    class="font-weight-black text-decoration-underline"
                    >Name</v-list-item-title
                  >
                  </v-col>
                  <v-col>
                  <v-list-item-title
                    >{{ waiter.name ? waiter.name:'---' }}</v-list-item-title
                  >
                  </v-col>
                </v-list-item-content>
             </v-row>
              </v-list-item>
             
              <v-list-item href="#">
                <v-list-item-action>
                  <v-icon color="indigo">mail</v-icon>
                </v-list-item-action>
                <v-row>
                <v-list-item-content>
                  <v-col>
                
                  <v-list-item-title
                    class="font-weight-black text-decoration-underline"
                    >Mail</v-list-item-title
                  >
                  </v-col>
                  <v-col>
                  <v-list-item-title>{{ waiter.contact.email ? waiter.contact.email:'---' }}</v-list-item-title>
                  </v-col>
                </v-list-item-content>
                </v-row>
              </v-list-item>
              <v-list-item>
                <v-list-item-action>
                  <v-icon color="indigo">mdi-account-key</v-icon>
                </v-list-item-action>
                <v-row>
                <v-list-item-content>
                  <v-col>
                  <v-list-item-title
                    class="font-weight-black text-decoration-underline"
                    >Waiter app</v-list-item-title
                  >
                  </v-col>
                  <v-col>
                  <v-list-item-title>{{ appAccess.linked ? appAccess.user.username : 'No login yet' }}</v-list-item-title>
                  </v-col>
                </v-list-item-content>
                </v-row>
              </v-list-item>
              
        
            </v-list>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" md="8" lg="8">
          <v-card class="mb-15">
            <v-card-title>Contact</v-card-title>
            <v-list two-line class="pa-0">
              <v-list-item href="#">
                <v-list-item-action>
                  <v-icon color="indigo">mdi-phone-classic </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ waiter.contact.telephone ?  waiter.contact.telephone:'---'}}</v-list-item-title
                  >

                  <v-list-item-sub-title
                    >Telephone Number</v-list-item-sub-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-divider inset></v-divider>
              <v-list-item href="#">
                <v-list-item-action>
                  <v-icon color="indigo">mdi-cellphone-basic</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    {{  waiter.contact.phone ?  waiter.contact.phone:'---' }}</v-list-item-title
                  >
                  <v-list-item-sub-title>Mobile Number</v-list-item-sub-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>

          <v-card class="address-card">
            <v-card-title>Address</v-card-title>
            <v-list two-line class="pa-0">
              <v-list-item href="#">
                <v-list-item-action>
                  <v-icon color="indigo">mdi-mailbox-open-up</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-sub-title>Postal Code</v-list-item-sub-title>
                  <v-list-item-title>{{waiter.address.postal_code ? waiter.address.postal_code:'----'
                    
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider inset></v-divider>
              <v-list-item href="#">
                <v-list-item-action>
                  <v-icon color="indigo">mdi-map-search-outline</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-sub-title>Address line 1</v-list-item-sub-title>
                  <v-list-item-title>
                    {{ waiter.address.address_line1 ? waiter.address.address_line1:'---' }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-divider inset></v-divider>
              <v-list-item href="#">
                <v-list-item-action>
                  <v-icon color="indigo">mdi-map-outline</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-sub-title>Address line 2</v-list-item-sub-title>
                  <v-list-item-title>{{
                    waiter.address.address_line2 ? waiter.address.address_line2:'---'
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider inset></v-divider>
              <v-list-item href="#">
                <v-list-item-action>
                  <v-icon color="indigo">mdi-city</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-sub-title>City</v-list-item-sub-title>
                  <v-list-item-title>
                    {{  waiter.address.city ? waiter.address.city:'---'  }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-divider inset></v-divider>
              <v-list-item href="#">
                <v-list-item-action>
                  <v-icon color="indigo">mdi-map-outline</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-sub-title>Country</v-list-item-sub-title>
                  <v-list-item-title>
                    {{waiter.address.country.name ? waiter.address.country.name:'---'
                      
                    }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>
        
      </v-row>
    </v-container>





  </div>
</template>
<script>
import { required, email, max, regex } from "vee-validate/dist/rules";
import axios from "@/plugins/axios";


import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";

setInteractionMode("eager");

extend("required", {
  ...required,
  message: "{_field_} is required",
});

extend("max", {
  ...max,
  message: "{_field_} may not be greater than {length} characters",
});

extend("email", {
  ...email,
  message: "Email must be valid",
});

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data: () => ({
  
    checkbox: null,
    waiter:[],
    
    errors: [],
    
    messages: [],
    appAccess: { linked: false, user: null },
  }),

  methods: {
    submit() {
      this.$refs.observer.validate();
      this.Editwaiter();
    },
 
    Reset() {
      this.waiter = this.oldwaiterDetails;
      this.$refs.observer.reset();
    },
    loadAppAccess() {
      axios
        .get(`hms/waiters/${this.$route.params.id}/app-access`)
        .then((res) => {
          this.appAccess = res.data || { linked: false, user: null };
        })
        .catch(() => {
          this.appAccess = { linked: false, user: null };
        });
    },
    getWaiter() {
      
      let waiterId = this.$route.params.id;

      this.$store
        .dispatch("waiter/GetSingleWaiter", waiterId)
        .then((res) => {
          
          //this.succeeed = true;

          this.waiter = res.data;
       
        })
        .catch((err) => {
          this.messages.push(err.data);
          // this.$router.push("/pages/404");
          console.log(err);
        });
    },
   
 
  
  },
  created(){
    this.getWaiter()
    this.loadAppAccess()
  }

};
</script>
